import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${rem(13)};
  ${({ theme }) => theme.media.s`
display: none;
`};
`;

export const DesktopWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.media.s`
display: flex;
`};
`;

export const MProductWrapper = styled.div`
background: ${props => (props.even ? '#f2f6fa' : 'unset')}
border:  ${props => (props.green ? rem(3) : rem(1))} solid  ${props =>
  props.green ? ({ theme }) => theme.color.primary : '#c2ccd5'};
${props => {
  if (!props.green) {
    return css`
  border-top: ${props.first ? rem(1) : 0} solid '#c2ccd5'};
  `;
  }
  return css``;
}}

padding: ${rem(20)};
display: flex;
    justify-content: center;
    align-items: center;
`;

export const MProductContentWrapper = styled.div`
  max-width: ${rem(350)};
`;

export const MContentRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: ${rem(4)};
  margin-top: ${rem(4)};
  align-items: center;
`;

export const MButtonRow = styled(MContentRow)`
  margin-top: ${rem(10)};
  justify-content: flex-end;
`;

export const MLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  width: ${rem(100)};
`;

export const MValue = styled.div`
  font-weight: 600;
  margin-left: ${rem(5)}
  display: flex;
  justify-content: flex-start;
`;



// WEBPACK FOOTER //
// ./src/Components/ReusableComponents/Table/index.jsx